import React, { Component } from "react";

const Timer = ({ width, height, fill, ...rest }) => {
  return (
    <>
      <svg
        width={width}
        height={height}
        viewBox="0 0 28 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...rest}
      >
        <path
          d="M14.75 7.5V7.4H14.65H12.7H12.6V7.5V15.3V15.3566L12.6486 15.3857L19.4736 19.4807L19.5587 19.5318L19.6104 19.4471L20.5854 17.8481L20.6381 17.7616L20.551 17.71L14.75 14.2681V7.5ZM21.2832 21.2832C19.3516 23.2148 16.7317 24.3 14 24.3C11.2683 24.3 8.64842 23.2148 6.7168 21.2832C4.78518 19.3516 3.7 16.7317 3.7 14C3.7 11.2683 4.78518 8.64842 6.7168 6.7168C8.64842 4.78518 11.2683 3.7 14 3.7C16.7317 3.7 19.3516 4.78518 21.2832 6.7168C23.2148 8.64842 24.3 11.2683 24.3 14C24.3 16.7317 23.2148 19.3516 21.2832 21.2832ZM19.0132 1.89718C17.4238 1.23884 15.7203 0.9 14 0.9C10.5257 0.9 7.19363 2.28017 4.7369 4.7369C2.28017 7.19363 0.9 10.5257 0.9 14C0.9 21.205 6.75558 27.1 14 27.1C17.4743 27.1 20.8064 25.7198 23.2631 23.2631C25.7198 20.8064 27.1 17.4743 27.1 14C27.1 12.2797 26.7612 10.5762 26.1028 8.98685C25.4445 7.39748 24.4795 5.95335 23.2631 4.7369C22.0466 3.52045 20.6025 2.55551 19.0132 1.89718Z"
          fill={fill}
          stroke={fill}
          strokeWidth="0.2"
        />
      </svg>
    </>
  );
};

Timer.defaultProps = {
  width: 14,
  height: 14,
  fill: "white",
};

export default Timer;
